angular.module('TetherApp').controller('KeywordController', [
    '$window',
    'keywordService',
    function (
        $window,
        keywordService
    ) {
        let self = this;

        self.delete = function(keywordId) {
            if($window.confirm(self.deleteConfirmationText)) {
                keywordService.deleteKeyword(keywordId)
                    .then(onKeywordDelete, onError);
            }
        };

        let onKeywordDelete = function (data) {
            $window.location.reload();
        };

        let onError = function(reason) {
            // console.log('Error occurred while deleting keyword');
        };
    }
]);
